"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var journeyListStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        listContainer: {
            display: 'block',
            marginBottom: '30px',
            padding: 0,
        },
        listItem: {
            boxShadow: "0 0 2px " + theme.palette.text.primary,
            width: '100%',
            cursor: 'pointer',
        },
        selected: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '& $title': {
                color: theme.palette.primary.contrastText,
            },
            '& $description': {
                color: theme.palette.primary.contrastText,
            },
            '& $radio': {
                '&$checked': {
                    color: theme.palette.primary.contrastText,
                },
            },
        },
        title: {},
        description: {},
        radio: {},
        checked: {},
        icon: {
            width: '20px',
            minWidth: '20px',
            marginRight: '20px',
        },
        buttonWrapper: (_a = {
                display: 'flex',
                flexDirection: 'column'
            },
            _a[theme.breakpoints.down('xs')] = {
                alignItems: 'center',
            },
            _a),
        selectedIcon: {},
        radioIcon: {},
        hideSelection: {
            display: 'none',
        },
        error: {
            color: theme.palette.error.main,
            marginBottom: '20px',
        },
    });
}, { name: 'Checkout4_JourneyList' });
exports.default = journeyListStyles;
